import { PathomProfile } from 'wsscode_blog/com.wsscode.blog.components.benchmark_render';
import * as React from 'react';
export default {
  PathomProfile,
  React
};